import { Injectable } from '@angular/core';
import { CONFIG } from '../../environments/config';
import { HttpClientService } from './http-client.service';

@Injectable({
  providedIn: 'root'
})
export class AccountService {
  constructor(private httpClientService: HttpClientService) { }

  public getAllAccounts(data: any) {
    return this.httpClientService.post(`${CONFIG.ACCOUNT.GETALLACCOUNT}`, data);
  }
  public getAllActiveAccounts() {
    return this.httpClientService.get(`${CONFIG.ACCOUNT.GETALLACTIVEACCOUNT}`);
  }

  public getAccountsId(data: any) {
    let queryParam = `id=${data}`;
    return this.httpClientService.get(`${CONFIG.ACCOUNT.GETACCOUNT}?${queryParam}`);
  }

  public getAccountGroupTypeId(data: any) {
    let queryParam = `id=${data}`;
    return this.httpClientService.get(`${CONFIG.ACCOUNT.GETACCOUNTGROUPTYPE}?${queryParam}`);
  }

  public getAccountSubGroupTypeId(data: any) {
    let queryParam = `id=${data}`;
    return this.httpClientService.get(`${CONFIG.ACCOUNT.GETACCOUNTSUBGROUPTYPE}?${queryParam}`);
  }
  public createAccount(data: any) {
    return this.httpClientService.post(`${CONFIG.ACCOUNT.CREATEACCOUNT}`, data);
  }

  public updateAccount(data: any) {
    return this.httpClientService.post(`${CONFIG.ACCOUNT.UPDATEACCOUNT}`, data);
  }

  public deleteAccount(data: any) {
    return this.httpClientService.post(`${CONFIG.ACCOUNT.DELETEACCOUNT}`, data);
  }



  public getAllAccountTypes(data: any) {
    return this.httpClientService.post(`${CONFIG.ACCOUNT.GETALLACCOUNTTYPE}`, data);
  }

  public getAccountTypeId(data: any) {
    let queryParam = `id=${data}`;
    return this.httpClientService.get(`${CONFIG.ACCOUNT.GETACCOUNTTYPE}?${queryParam}`);
  }

  public createAccountType(data: any) {
    return this.httpClientService.post(`${CONFIG.ACCOUNT.CREATEACCOUNTTYPE}`, data);
  }

  public updateAccountType(data: any) {
    return this.httpClientService.post(`${CONFIG.ACCOUNT.UPDATEACCOUNTTYPE}`, data);
  }

  public deleteAccountType(data: any) {
    return this.httpClientService.post(`${CONFIG.ACCOUNT.DELETEACCOUNTTYPE}`, data);
  }



  public getAllAccountGroups(data: any) {
    return this.httpClientService.post(`${CONFIG.ACCOUNT.GETALLACCOUNTGROUP}`, data);
  }
  public getAllAccountSubGroups(data: any) {
    return this.httpClientService.post(`${CONFIG.ACCOUNT.GETALLACCOUNTSUBGROUP}`, data);
  }

  public getAccountGroupId(data: any) {
    let queryParam = `id=${data}`;
    return this.httpClientService.get(`${CONFIG.ACCOUNT.GETACCOUNTGROUP}?${queryParam}`);
  }

  public createAccountGroup(data: any) {
    return this.httpClientService.post(`${CONFIG.ACCOUNT.CREATEACCOUNTGROUP}`, data);
  }

  public updateAccountGroup(data: any) {
    return this.httpClientService.post(`${CONFIG.ACCOUNT.UPDATEACCOUNTGROUP}`, data);
  }

  public deleteAccountGroup(data: any) {
    return this.httpClientService.post(`${CONFIG.ACCOUNT.DELETEACCOUNTGROUP}`, data);
  }

  public searchAccount(seachkey: string) {
    return this.httpClientService.get(`${CONFIG.ACCOUNT.SEARCHACCOUNT}?searchText=${seachkey}`);
  }
  // ---------------------BANK---------------------------
  public getAllBank(data: any) {
    return this.httpClientService.post(`${CONFIG.BANK.GETALLBANK}`, data);
  }
  public getBankId(data: any) {
    let queryParam = `id=${data}`;
    return this.httpClientService.get(`${CONFIG.BANK.GETBANK}?${queryParam}`);
  }
  public createBank(data: any) {
    return this.httpClientService.post(`${CONFIG.BANK.CREATEBANK}`, data);
  }
  public autogenerateBankCode() {
    return this.httpClientService.get(CONFIG.BANK.AUTOGENERATE_BANKCODE);
  }
  public checkBankCode(data: any) {
    return this.httpClientService.get(`${CONFIG.BANK.CHECK_BANK_CODE}?BankCode=${data}`);
  }
  public checkBankName(data: any) {
    return this.httpClientService.get(`${CONFIG.BANK.CHECK_BANK_NAME}?BankName=${data}`);
  }
  public deleteBank(data: any) {
    return this.httpClientService.post(`${CONFIG.BANK.DELETEBANK}`, data);
  }
  public updateBank(data: any) {
    return this.httpClientService.post(`${CONFIG.BANK.UPDATEBANK}`, data);
  }
  public getAllCurrency(data: any) {
    return this.httpClientService.post(`${CONFIG.BANK.GETALLCURRENCY}`, data);
  }
  public searchBank(seachkey: string) {
    return this.httpClientService.get(`${CONFIG.BANK.AUTOSEARCHBANK}?searchText=${seachkey}`);
  }
  public autogenerateAccountGroupCode() {
    return this.httpClientService.get(CONFIG.ACCOUNT.AUTOGENERATE_ACCOUNTGROUPCODE);
  }
  public autogenerateAccountCode(accountTypeCode: string) {
    return this.httpClientService.get(`${CONFIG.ACCOUNT.AUTOGENERATE_ACCOUNTCODE}?AccountType=${accountTypeCode}`);
  }
  public checkAccountCode(data: any) {
    return this.httpClientService.get(`${CONFIG.ACCOUNT.CHECK_ACCOUNT_CODE}?AccountCode=${data}`);
  }
  public checkAccountGroupCode(data: any) {
    return this.httpClientService.get(`${CONFIG.ACCOUNT.CHECK_ACCOUNTGROUP_CODE}?AccountGroupCode=${data}`);
  }
  public checkAccountTypeCode(data: any) {
    return this.httpClientService.get(`${CONFIG.ACCOUNT.CHECK_ACCOUNTTYPE_CODE}?AccountTypeCode=${data}`);
  }
  public autogenerateAccountTypeCode() {
    return this.httpClientService.get(CONFIG.ACCOUNT.AUTOGENERATE_ACCOUNTTYPECODE);
  }
  public autogenerateAccountSubGroupCode() {
    return this.httpClientService.get(CONFIG.ACCOUNT.AUTOGENERATE_ACCOUNTSUBGROUPCODE);
  }
  public checkAccountSubGroupCode(data: any) {
    return this.httpClientService.get(`${CONFIG.ACCOUNT.CHECK_ACCOUNTSUBGROUP_CODE}?AccountSubGroupCode=${data}`);
  }

  public createAccountSubGroup(data: any) {
    return this.httpClientService.post(`${CONFIG.ACCOUNT.CREATEACCOUNTSUBGROUP}`, data);
  }

  //------------------------------------ManualJournals-------------------------------
  public getAllManualJournals(data: any) {
    return this.httpClientService.post(`${CONFIG.MANALJOURNALS.GETALLMANALJOURNALS}`, data);
  }

  public GetManualJournalsById(data: any) {
    let queryParam = `id=${data}`;
    return this.httpClientService.get(`${CONFIG.MANALJOURNALS.GETMANALJOURNALS}?${queryParam}`);
  }


  public createManualJournals(data: any) {
    return this.httpClientService.post(`${CONFIG.MANALJOURNALS.CREATEMANALJOURNALS}`, data);
  }

  public updateManualJournals(data: any) {
    return this.httpClientService.post(`${CONFIG.MANALJOURNALS.UPDATEMANALJOURNALS}`, data);
  }

  public deleteManualJournals(data: any) {
    return this.httpClientService.post(`${CONFIG.MANALJOURNALS.DELETEMANALJOURNALS}`, data);
  }
  public searchManualJournals(seachkey: string) {
    return this.httpClientService.get(`${CONFIG.MANALJOURNALS.AUTOSEARCHMANALJOURNALS}?searchText=${seachkey}`);
  }
  public createManualJournalLineItem(data: any) {
    return this.httpClientService.post(`${CONFIG.MANALJOURNALS.CREATEMANALJOURNALSLINEITEM}`, data);
  }
  public getManualJournalLineItemsById(id: number) {
    return this.httpClientService.get(
      `${CONFIG.MANALJOURNALS.GETMANALJOURNALSLINEITEMBYID}/${id}`
    );
  }

  public deleteManualJournalsLineItems(data: any) {
    return this.httpClientService.post(`${CONFIG.MANALJOURNALS.DELETEMANALJOURNALSLINEITEM}`, data);
  }
  public updateManualJournalsLineItems(data: any) {
    return this.httpClientService.post(`${CONFIG.MANALJOURNALS.UPDATEMANALJOURNALSLINEITEM}`, data);
  }

  public postJournalToGL(data: any) {
    return this.httpClientService.post(`${CONFIG.MANALJOURNALS.POSTTRANSACTION}`, data);
  }

  public postJournalBatchToGL(data: any[]) {
    return this.httpClientService.post(`${CONFIG.MANALJOURNALS.POSTTRANSACTIONSBATCH}`, data);
  }

  public postManualJournal(data: any) {
    return this.httpClientService.post(`${CONFIG.MANALJOURNALS.POST_MANUAL_JOURNAL}`, data);
  }

  public voidManualJournal(data: any) {
    return this.httpClientService.post(`${CONFIG.MANALJOURNALS.VOID_MANUAL_JOURNAL}`, data);
  }

  public getAccountBalance(accountsId: number) {
    return this.httpClientService.get(`${CONFIG.ACCOUNT.GET_ACCOUNT_BALANCE}?accountsId=${accountsId}`);
  }

  public getAccountLedger(accountsId: number, fromDate?: string, toDate?: string) {
    let query = `accountsId=${accountsId}`;
    if (fromDate) query += `&fromDate=${fromDate}`;
    if (toDate) query += `&toDate=${toDate}`;
    return this.httpClientService.get(`${CONFIG.ACCOUNT.GET_ACCOUNT_LEDGER}?${query}`);
  }

  public recalculateGlBalances() {
    return this.httpClientService.post(`${CONFIG.ACCOUNT.RECALCULATE_GL_BALANCES}`, {});
  }

  public getAccountByCode(data: any) {
    let queryParam = `code=${data}`;
    return this.httpClientService.get(`${CONFIG.ACCOUNT.GETACCOUNTBYCODE}?${queryParam}`);
  }
  public markManualJournalGlPosted(data: any) {
    return this.httpClientService.post(`${CONFIG.MANALJOURNALS.MARKGLPOSTED}`, data);
  }


  //GL DEFAULT
  public saveDefaultGL(data: any) {
    return this.httpClientService.post(`${CONFIG.ACCOUNT.SAVEDEFAULTGL}`, data);
  }

  public getGLDefaultsByWarehouse(warehouseId: number) {
    return this.httpClientService.get(`${CONFIG.ACCOUNT.GET_GLDEFAULTS_BY_WAREHOUSE}/${warehouseId}`);
  }

  public saveOrUpdateGLDefaults(data: any) {
    return this.httpClientService.post(`${CONFIG.ACCOUNT.SAVEUPDATEDEFAULTGL}`, data);
  }

  public getAccountTypes() {
    return this.httpClientService.get(CONFIG.ACCOUNT.GET_ACCOUNTTYPE_LIST);
  }
  public getAccounts() {
    return this.httpClientService.get(CONFIG.ACCOUNT.GET_ACCOUNTS);
  }
}
